export { default as default } from './AdditionalInfoEDS';
